/**
 * TypeScript types for Actions module
 */

export type ActionStatus = 'backlog' | 'doing' | 'review' | 'done'
export type ActionPriority = 'low' | 'medium' | 'high'

export interface User {
  id: number
  email: string
  first_name: string
  last_name: string
  full_name: string
  avatar_url: string | null
}

export interface Label {
  id: string
  name: string
  color: string
  created_at: string
}

export interface Comment {
  id: string
  text: string
  user: User
  created_at: string
}

export interface InteractionDetails {
  id: string
  ragflow_session_id: string
  visitor_name: string
  visitor_email: string | null
  created_at: string
  message_count: number
}

export interface ActionItem {
  id: string
  title: string
  description?: string
  status: ActionStatus
  priority: ActionPriority
  assignee: User | null
  reporter: User
  labels: Label[]
  comment_count: number
  created_at: string
  updated_at: string
  is_archived: boolean
  interaction: string | null
  interaction_details?: InteractionDetails | null
  comments?: Comment[]
}

export interface ActionItemsGrouped {
  backlog: ActionItem[]
  doing: ActionItem[]
  review: ActionItem[]
  done: ActionItem[]
}

export interface CreateActionItemData {
  title: string
  description?: string
  status?: ActionStatus
  priority?: ActionPriority
  assignee?: number | null
  label_ids?: string[]
  interaction?: string | null
}

export interface UpdateActionItemData {
  title?: string
  description?: string
  status?: ActionStatus
  priority?: ActionPriority
  assignee?: number | null
  label_ids?: string[]
}

export interface ActionFilters {
  status?: string
  priority?: string
  assignee?: string
  unassigned?: boolean
  my_tasks?: boolean
  labels?: string
  search?: string
  archived?: boolean
}

export interface CreateCommentData {
  text: string
}

export interface CreateLabelData {
  name: string
  color: string
}

// Priority colors for UI
export const PRIORITY_COLORS: Record<ActionPriority, string> = {
  low: '#6B7280',      // Gray
  medium: '#F59E0B',   // Amber
  high: '#EF4444',     // Red
}

// Status display names
export const STATUS_LABELS: Record<ActionStatus, string> = {
  backlog: 'Backlog',
  doing: 'Doing',
  review: 'Review',
  done: 'Done',
}

// Priority display names
export const PRIORITY_LABELS: Record<ActionPriority, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
}
